import {React, _, observer, useEffect, QueryResult, enums, useLocalStore, useAsObservableSource} from '@api'
import {IFilterGroupItem} from '@api/graphql'
import {RangeSlider} from '@blueprintjs/core'
import {FILTER_UNASSIGNED_ID, FilterItemState, FilterKey, FilterStore, useFilterStore, useVipLocalStore} from '@modules'
import {FilterGroupItem} from './FilterGroupItem'
import {FilterSpecGroupItem} from './FilterSpecGroupItem'
import {VipLocalStore} from '@modules'
import {ui, FilterRendererType, isNumericAttribute, StoresInstance} from '@stores'
import {action, autorun, computed, toJS} from 'mobx'
import {useContext} from 'react'
import * as css from './FilterGroupItems.css'

export const UNASSIGNED_FILTER_ITEM = {id: FILTER_UNASSIGNED_ID}

interface MyProps {
  showIcon?: boolean,
  displayName?: string,
  unassigned?: Partial<QueryResult>
  group: FilterKey,
  loading?: boolean
  topToShow?: number,
  ignoreSearch?: boolean
  data: Array<IFilterGroupItem>
}

export class FilterGroupsItemsStore extends VipLocalStore {
  constructor (stores: StoresInstance, public props: Partial<MyProps>) {
    super(stores)
    this.filter.state.groups[props.group].itemsStore = this
  }

  @computed get groupState() {
    return this.filter.state.groups[this.props.group]
  }

  @computed get searchResults(): Array<IFilterGroupItem> {
    const {filter: {state: {search}}, props: {data, topToShow}, groupState} = this

    return data
    //return !search ? data : searcher && data ? searcher.search(search, {limit: groupState?.selected?.size + topToShow}).map(({item}) => item as IFilterGroupItem) : []
  }

  @computed get selectedSet() {
    return this.groupState?.selected || new Map<string, FilterItemState>()
  }

  @computed get excludedSet() {
    return this.groupState?.excluded || new Map<string, FilterItemState>()
  }

  /*@computed get grouped() {
    const {selectedSet, excludedSet, props: {group, data}, groupState} = this
    //console.log(filtered)

    // Group the filter choices by checked, unchecked, unavailable (no associated items)
    let r = _.groupBy(
      data,
      filterValue => {
        //if (group === 'attributes.Active' && selectedSet.size) debugger

        return selectedSet?.has(filterValue.id) || excludedSet?.has(filterValue.id) || selectedSet?.has(filterValue.compoundId) || excludedSet?.has(filterValue.compoundId)
               ? 'selected'
               : (filterValue.count || groupState.def?.type === 'Boolean') && (group == 'tag' || group == enums.MERCH_OPTION_VERSION_TAG_DEFINITION_NAME || group == 'productComments' || groupState.def)
               ? 'available'
               : 'empty'
      });

    // There may be some items marked as 'selected' that are not in the actual result set, add them
      (selectedSet ? Array.from(selectedSet.keys()) : []).forEach(k => {
        if (!r.selected?.some(s => s.id == k || s.compoundId == k)) {
          const item = { id: k, compoundId: k, count: 0, name: k}

          r.selected = [...(r.selected ?? []), item]
        }
      })

    // selectedSet.size > 0 && console.log({group, r, data, selected: Array.from(selectedSet.keys())})
    return r
  }
*/
  @computed get fieldDefinition() {
    return this.catalog._fieldByName[this.props.group]
  }

  @computed get finalList() {
    const {props: {data, ignoreSearch}, fieldDefinition, filter} = this
    if (_.isUndefined(data)) return [] // During initial load we don't want to render any items

    let results = data

    // if (ignoreSearch && !_.isEmpty(fieldDefinition?.sort?.custom?._key?.order)) {
    //   const {sort: {custom: {_key: {order}}}} = fieldDefinition
    //   if (order.length != results.length) {
    //     const resultById = _.keyBy(results, r => r.compoundId)
    //     results = order.map(v => ({
    //       compoundId: v,
    //       id: v,
    //       count: null
    //     }))
    //   }
    //   debugger
    // }

    return filter.sortFilterResults(results, fieldDefinition)
  }

  /*@computed get finalList() {
    const {grouped: {available, selected}, props: {data}, fieldDefinition} = this
    if (_.isUndefined(data)) return [] // During initial load we don't want to render any items

    // For everyone but tags, only show the top N items (as well as all checked items)
    const topValid = available ?? [] //? _.take(available, group != 'tag' && group != enums.MERCH_OPTION_VERSION_TAG_DEFINITION_NAME && available.length > 15 ? topToShow : available.length) : []
    let finalList = [...(selected || []), ...(topValid || [])]
    finalList = _.orderBy(finalList, v => v?.name === strings.unassigned ? 999999 : fieldDefinition?.sort?.custom?._key ? fieldDefinition.sort.custom._key.order.indexOf(v.toString()) : _.isNumber(v.id) ? v.id : _.toLower(labelFor(v)))

    //_.orderBy([...(selected || []), ...(topValid || [])], [v => _.toLower(labelFor(v)), 'id'])
    return finalList
  }*/

  @computed get dataDict() { return _.keyBy(this.props.data, 'id') }

  @computed get checkedButFiltered() { return Array.from(this.selectedSet.keys()).filter(k => k != FILTER_UNASSIGNED_ID && !this.dataDict[k]) }
  @computed get checkedFromMore() {
    const {props: {group}, checkedButFiltered, filter: {state}} = this
    return _.map(checkedButFiltered, checked => _.find(state.more[group], (g: any) => g.name == checked.toString().trim())).filter(_.identity)
  }
  /*
  const checkedButFiltered = useComputed(() =>

  const checkedFromMore = useComputed(() => , [checkedButFiltered, more]).filter(_.identity)
   */

  @computed get renderer() : FilterRendererType {
    if (!this.fieldDefinition) return 'label'
    const {fieldDefinition: {filter, def}} = this
    return _.isBoolean(filter) || !filter?.renderer ? (isNumericAttribute ? isNumericAttribute(def) ? 'range' : 'label' : 'label') : filter.renderer
  }
}

export const FilterGroupsItemsContext = React.createContext<FilterGroupsItemsStore>(undefined)
export const useFilterGroupsItemsStore = () => useContext(FilterGroupsItemsContext)

/**
 * Transform the raw list of all spec values into the filtered list of the top N items + extras giving precedence to selected values
 * @param data
 * @constructor
 */
export const FilterGroupItems = observer<MyProps>(function FilterGroupItems(props) {
  const {loading, displayName, showIcon, unassigned, group, topToShow = 9, data, ignoreSearch} = props,
    obsProps = useAsObservableSource({group, data, topToShow, unassigned, ignoreSearch}),
    store = useVipLocalStore((ws) => new FilterGroupsItemsStore(ws, obsProps)),
    {catalog: {labelFor, libraryTypes}, groupState, finalList, selectedSet, excludedSet, checkedFromMore, renderer } = store

  useEffect(() => {
    groupState.visibleCount = finalList.length
  }, [finalList])

  // console.log({group, finalList: toJS(finalList)})

  //console.log({filtered: toJS(filtered), finalList: toJS(finalList), checkedFromMore: toJS(checkedFromMore), selected: toJS(selected), available: toJS(available)})
  return (
    <FilterGroupsItemsContext.Provider value={store}>
      {false && renderer == 'range' && <RangeSlider className={css.range} vertical min={100} max={500} value={[100, 500]} labelStepSize={100} />}
      {finalList.map((specItem: any, i) => {
        let count = specItem.count

        return <FilterSpecGroupItem
          selected={selectedSet}
          excluded={excludedSet}
          item={specItem}
          count={count}
          key={`${i}-${specItem.sectionValue ? `${specItem.sectionValue}.` : ''}${specItem.id}`}
          group={group}
          type={group}
          displayName={libraryTypes[group]?.label || displayName}
          showIcon={showIcon}
        />
      })}
      {checkedFromMore.map((c:any, i) => {
        return <FilterGroupItem
          key={`${i}-c.name`}
          item={c}
          name={labelFor(c.name)}
          checked
          count={loading ? '...' : c.count}
          //onChange={() => selectedSet.delete(c.name)}
        />
      })}

      {/*{loading && <span>Loading...</span>}*/}
    </FilterGroupsItemsContext.Provider>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/FilterGroupItems.tsx